export type SpotlightBodyHydratedProps = {
	bodyHtml: string
}

/**
 * Renderiza o HTML do corpo do artigo de novidades (Fase 2).
 * O pipeline servidor já omitiu links internos de app; não há hidratação client-side.
 */
export function SpotlightBodyHydrated({ bodyHtml }: SpotlightBodyHydratedProps) {
	return (
		<div
			className="spotlight-article-body"
			dangerouslySetInnerHTML={{ __html: bodyHtml }}
		/>
	)
}
